import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, MessageCircle, MapPin, Clock, Phone } from 'lucide-react';
import { showroomDetails } from '../mockData';

const Footer = () => {
  const navigate = useNavigate();

  const whatsappClick = () => {
    window.open(`https://wa.me/${showroomDetails.phone.replace(/\+/g, '')}`, '_blank');
  };

  const igClick = () => {
    window.open('https://www.instagram.com/bikers_galleria/', '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-brand" style={{ fontSize: '28px', marginBottom: '12px' }}>BIKERS GALLERIA</h3>
            <p className="footer-tagline" style={{ fontSize: '16px', lineHeight: '1.6' }}>
              Your trusted partner in rider safety. Premium gear, expert guidance.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Visit Us</h4>
            <address className="footer-address" style={{ fontStyle: 'normal' }}>
              <p className="footer-address-line" style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', marginBottom: '10px' }}>
                <MapPin size={16} style={{ flexShrink: 0, marginTop: '3px', color: 'var(--brand-primary)' }} />
                <span>Kunal Icon Rd, beside Saibaba Mandir,<br />Pimple Saudagar, Pimpri-Chinchwad,<br />Maharashtra 411027</span>
              </p>
              <p style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px' }}>
                <Phone size={15} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                <a href={`tel:${showroomDetails.phone}`} style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>{showroomDetails.phone}</a>
              </p>
              <p style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '16px' }}>
                <Clock size={15} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                <span>{showroomDetails.hours} &nbsp;·&nbsp; {showroomDetails.daysOpen}</span>
              </p>
            </address>
            <a
              href={showroomDetails.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="maps-link"
            >
              <MapPin size={15} /> Open in Google Maps
            </a>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '16px' }}>
              <button onClick={whatsappClick} className="whatsapp-button">
                <MessageCircle size={20} />
                Chat on WhatsApp
              </button>
              <button onClick={igClick} className="whatsapp-button">
                <Instagram size={20} />
                Connect on IG
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2024 Bikers Galleria. All rights reserved.
          </p>
          <div className="footer-legal">
            <button onClick={() => navigate('/privacy-policy')} className="footer-legal-link">Privacy Policy</button>
            <span className="footer-separator">•</span>
            <button onClick={() => navigate('/terms-of-service')} className="footer-legal-link">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
